module.exports = "/_next/static/images/AIAndML-sm@2x-4cfd06ca24ebc8ddf9609914e4a63000.webp";